<template>
  <div class="fair-survey-step">
    <div class="fair-survey-step__head">
      <h2 class="fair-survey-step__title">
        {{ step.title }}
      </h2>
      <p
        v-if="step.subtitle"
        class="fair-survey-step__subtitle"
      >
        {{ step.subtitle }}
      </p>
    </div>

    <div class="fair-survey-step__options">
      <button
        v-for="interest in step.interests"
        :key="interest.value"
        type="button"
        class="fair-survey-step__option"
        :class="{
          'fair-survey-step__option--selected': isSelected(interest.value),
        }"
        :aria-pressed="isSelected(interest.value)"
        @click="toggleInterest(interest.value)"
      >
        <FairCheckboxIndicator :checked="isSelected(interest.value)" />
        <span class="fair-survey-step__option-label">{{ interest.label }}</span>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { FairCheckboxIndicator } from '@/ui/primitives/FairCheckbox'
import { useGiftModal } from '@/features/gift/store'
import type { GiftStep } from '@/features/gift/types/gift-config'

interface Props {
  step: GiftStep & { type: 'interests' }
}

const props = defineProps<Props>()
const giftStore = useGiftModal()

const selectedInterests = ref<string[]>([])

function isSelected(value: string): boolean {
  return selectedInterests.value.includes(value)
}

function toggleInterest(value: string) {
  selectedInterests.value = isSelected(value)
    ? selectedInterests.value.filter((item) => item !== value)
    : [...selectedInterests.value, value]
  updateInterests()
}

function updateInterests() {
  giftStore.updateGiftData(props.step.id, selectedInterests.value)
}

onMounted(() => {
  const data = giftStore.giftModal.giftData
  selectedInterests.value = data[props.step.id] || []
})
</script>
